module.exports = __webpack_public_path__ + "static/img/120_TO8_1657.42418b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/120_TO8_1657.jpg
// module id = gcaw
// module chunks = 0